module.exports = __webpack_public_path__ + "img/mrt_x.85527245.jpg";